'use client';

import Link from 'next/link';
import Image from 'next/image';

export default function ProductCard({
  id,
  name,
  slug,
  price,
  originalPrice,
  rating,
  reviews,
  badge,
  badgeColor,
  image,
  priority = false,
}) {

  return (
    <Link href={slug ? `/products/${slug}` : "/products"} className="block h-full">
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden group transform hover:scale-[1.02] hover:-translate-y-1 h-full flex flex-col border-2 border-gray-100 hover:border-[#23994F]/30">

      <div className="relative bg-gradient-to-br from-[#23994F]/10 via-blue-50/50 to-white h-52 sm:h-64 flex items-center justify-center overflow-hidden">

        {image && (
          <Image
            src={image}
            alt={name}
            width={224}
            height={224}
            className="w-auto h-44 sm:h-56 object-contain group-hover:scale-105 transition-transform duration-500"
            loading={priority ? undefined : "lazy"}
            priority={priority}
            quality={80}
            sizes="(max-width: 640px) 176px, 224px"
          />
        )}

        {/* Badge garantie */}
        <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-lg">
          <span className="text-xs font-bold text-[#23994F]">Garantie 12 mois</span>
        </div>
      </div>


      <div className="p-5 sm:p-6 flex-grow flex flex-col bg-gradient-to-b from-white to-gray-50/30">
        <div className="flex-grow">
          <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3 sm:mb-4 line-clamp-2 group-hover:text-[#23994F] transition-colors duration-300 leading-tight">
            {name}
          </h3>

          <div className="space-y-2 mb-4 sm:mb-6">
            <div className="flex items-baseline gap-2 sm:gap-3">
              <span className="text-2xl sm:text-3xl font-bold text-[#23994F]">{price}€</span>
              {originalPrice && (
                <span className="text-sm sm:text-base text-gray-400 line-through font-medium">
                  {originalPrice}€
                </span>
              )}
            </div>
            {originalPrice && (
              <div className="inline-flex items-center gap-1 bg-green-100 px-2 py-1 rounded-full">
                <span className="text-xs font-bold text-green-700">
                  -{Math.round(((originalPrice - price) / originalPrice) * 100)}% d'économie
                </span>
              </div>
            )}
          </div>
        </div>


        <button className="w-full flex items-center justify-center gap-2 px-3 sm:px-4 py-3 min-h-11 bg-gradient-to-r from-[#23994F] to-[#1a7840] text-white font-bold text-sm sm:text-base rounded-xl hover:shadow-xl transition-all duration-300 transform group-hover:scale-[1.02]">
          <span className="hidden sm:inline">Voir les détails</span>
          <span className="sm:hidden">Détails</span>
          <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      </div>
    </Link>
  );
}
